import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "album-box" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.state.title), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_el_upload, {
        action: "https",
        "list-type": "picture-card",
        "on-preview": _ctx.handlePictureCardPreview,
        multiple: true,
        "on-remove": _ctx.handleRemove,
        drag: "",
        "http-request": _ctx.submitEvent,
        ref: "album",
        "auto-upload": false,
        limit: _ctx.state.count
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "el-icon-plus" }, null, -1)
        ])),
        _: 1
      }, 8, ["on-preview", "on-remove", "http-request", "limit"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.state.dialogVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.dialogVisible) = $event)),
        size: "tiny"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            style: {"height":"500px","margin":"0 auto","display":"block"},
            src: _ctx.state.dialogImageUrl,
            alt: "预览"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}